import * as React from "react";
import SelectTeam from "../../SelectTeam-new/SelectTeam";
import SelectAgent from "../../SelectAgent/SelectAgent";
import SelectFirm from "../../SelectFirm/SelectFirm";
import OpenInCrmButton from "../../OpenInCrmButton/OpenInCrmButton";
import Input from "../../Input-new/Input";
import Dropdown from "../../Dropdown/Dropdown";
import Modal from "../../Modal/Modal";
import { addDaysSkippingWeekends, convertToWords, formatNumber, numberToWords } from "../../../utils";
import moment from "moment";
import { STORE_LOI_DATA, TEAM, AGENTS, OFFICES } from "../../../consts/tables";
import { summitFirmId } from "../../../consts/env";
import { getData, manageData } from "../../../requests/CRUD";
import Checkbox from "../../CheckboxNew";
import { isFieldLocked } from "../../../access-levels";
import { downloadDocumentWord } from "../../../requests/repAgreement";
import { withEmbeddedImages } from "./RepAgreementForm";

// The Close field's "Before" option names a date rather than a number of days.
const CLOSE_BEFORE_DAYS = 70;
const defaultCloseDate = () => moment().add(CLOSE_BEFORE_DAYS, 'days').format('YYYY-MM-DD');

// The app's own copy of the Summit logo, for the Word letterhead. The printed
// form's S3 copy is served without a CORS header, so the browser cannot read it
// into the data: URI the converter needs.
const SUMMIT_WORD_LOGO = '/img/light-logo.png';

// The LOI prints at 16px; the .docx is set to match rather than take the
// converter's 10.5pt default.
const LOI_WORD_FONT_SIZE = 12;

// Air around the Word file's blocks, in px, set inline because the shapes
// these classes name are shared with the other generated documents.
const TERM_GAP = 30;          // between one Summary row and the next
const NON_BINDING_GAP = 24;   // above and below the non-binding paragraph
const PROPERTY_TOP_GAP = 24;  // above Property, the first of the terms

const ListingAgent = ({data, handleChangeDropdown, handleChangeInput, addNewItem, newAgent, newFirm, viewMode, deleted,userData, locks}) => {

    const [loiData,setLoiData]= React.useState({
        buyer:'',
        price:'',
        earnestMoney:'$50,000',
        contractConsideration:'$100',
        dueDeligence:'30 Days',
        financing:'',
        additionalDeposit:'',
        close:'60 Days',
        closeDate:defaultCloseDate(),
        commission:'',
        other:'',
        expiration:addDaysSkippingWeekends(moment(), 3).format('YYYY-MM-DD'),
        titleCompany:'',
        agentInfo:{}
    });
    const [loiOffice, setLoiOffice] = React.useState(null);
    const [titleCompany,setTitleCompany]= React.useState("   ");
    const [otherTitleCompany,setAddOtherTitleCompany]= React.useState("");
    const [loiModal,setLoiModal]= React.useState(false);
    const [ed,setEd]= React.useState(true);
    // "Before" replaces the day-count wording with a fixed close date, so it is
    // exclusive with ED/DD rather than a third state of the same toggle.
    const [closeBefore,setCloseBefore]= React.useState(false);
    const [otherCompany,setOtherCompany]= React.useState(false);
    const allowedEmails = ['wschubert@summitre.io', 'mcrovetti@summitre.io', 'shook@summitRE.io'];

    // Summit firm ID (same as CRUDProperty: SOURCE === "SUMMIT")
    const SUMMIT_FIRM_ID = summitFirmId;

    const handleSyncFirmListingAgent1 = () => {
        handleChangeDropdown(
            { LISTING_AGENT_4_FIRM: SUMMIT_FIRM_ID },
            undefined,
            undefined,
            "LISTING_AGENT_4_FIRM"
        );
    };

    const handleSyncFirmOutsideAgent = () => {
        const agentId = data.LISTING_AGENT_4;
        if (!agentId) return;
        const options = {
            column: ["ARCIMEDES_ROW_ID", "FIRM"],
            limit: { count: 1 },
            filter: [{ code: "ARCIMEDES_ROW_ID", text: String(agentId), type: "equal" }],
            filterType: "and",
        };
        getData({ tableCode: AGENTS, options }).then((res) => {
            if (res.success && res.data && res.data.length && res.data[0].FIRM != null && res.data[0].FIRM !== "") {
                handleChangeDropdown(
                    { LISTING_AGENT_4_FIRM: res.data[0].FIRM },
                    undefined,
                    undefined,
                    "LISTING_AGENT_4_FIRM"
                );
            }
        });
    };

    const resetLOIForm=()=>{
        setLoiData({
            buyer:'',
            price:'',
            earnestMoney:'$50,000',
            contractConsideration:'$100',
            dueDeligence:'30 Days',
            financing:'',
            additionalDeposit:'$50,000',
            close:'60 Days',
            closeDate:defaultCloseDate(),
            commission:'',
            other:'',
            expiration:addDaysSkippingWeekends(moment(), 3).format('YYYY-MM-DD'),
            titleCompany:'',
            agentInfo:{}
        });
        setTitleCompany("   ");
        setAddOtherTitleCompany("");
        setEd(true);
        setCloseBefore(false);
        setOtherCompany(false);
        setLoiModal(false);
    }

    const fetchTeamData = () => {
        const options = {
            column: ['FIRST_NAME', 'LAST_NAME', 'TITLE', 'DESCRIPTION', 'EMAIL', 'CELL_PHONE', 'CITY', 'STATE', 'ADDRESS', 'PHONE', 'IS_AGENT', 'ARCIMEDES_ROW_ID', 'ZIP', 'OFFICE_ID'],
            limit: { count: 1000 }
        };
        getData({ tableCode: TEAM, options }).then((res) => {
            if (res.success && res.data.length) {
                let agentname = res.data.find(({ EMAIL }) => (EMAIL === userData.email));
                // If user is a Transaction Coordinator, use Listing Agent 1's address info instead
                if (agentname && agentname.TITLE && agentname.TITLE.toLowerCase().includes('transaction coordinator') && data.LISTING_AGENT_1) {
                    const listingAgent1 = res.data.find(({ ARCIMEDES_ROW_ID }) => String(ARCIMEDES_ROW_ID) === String(data.LISTING_AGENT_1));
                    if (listingAgent1) {
                        agentname = listingAgent1;
                    }
                }
                if (agentname) {
                    setLoiData((prevLoiData) => ({ ...prevLoiData, agentInfo: agentname }));
                    if (agentname.OFFICE_ID != null && agentname.OFFICE_ID !== '') {
                        getData({
                            tableCode: OFFICES,
                            options: {
                                limit: { count: 1 },
                                filter: [{ code: 'ARCIMEDES_ROW_ID', text: String(agentname.OFFICE_ID), type: 'exact' }],
                                filterType: 'and',
                            },
                        }).then((officeRes) => {
                            if (officeRes.success && officeRes.data && officeRes.data.length) {
                                setLoiOffice(officeRes.data[0]);
                            } else {
                                setLoiOffice(null);
                            }
                        }).catch(() => setLoiOffice(null));
                    } else {
                        setLoiOffice(null);
                    }
                } else {
                    setLoiOffice(null);
                }
            }
        });
    }
    React.useEffect(() => {
        if(titleCompany && titleCompany.toLowerCase()==='other'){
            setOtherCompany(true);
        }
      }, [titleCompany,otherCompany]); 

    React.useEffect(() => {
        fetchTeamData();
        // !important + first-in-head: the bundled PrintBooklet.scss ships a global
        // `@page { size: 11in 8.5in !important }` (landscape) that leaks into every
        // route. Among competing !important @page sizes Chromium honors the FIRST in
        // document order (see PrintContinuum.js), so this portrait rule must sit
        // before the bundle; the last-in-head copy covers spec-correct engines
        // where the last one wins.
        const css = `
        @media print {
            @page {
                size: portrait !important;
                margin: 0 !important;
            }
        }`;
        const first = document.createElement('style');
        first.innerHTML = css;
        const last = document.createElement('style');
        last.innerHTML = css;
        document.head.insertBefore(first, document.head.firstChild);
        document.head.appendChild(last);
        return () => {
            document.head.removeChild(first);
            document.head.removeChild(last);
        };
    }, []);

    // Name the printed/saved LOI file (tab title + suggested filename) instead of the app's title.
    // Uses beforeprint/afterprint so it works for ANY print trigger — the LOI button, Ctrl+P, or the browser menu.
    // Format: LOI - {Property Name} - {City}, {State} ({Buyer Name}) {Date}
    React.useEffect(() => {
        let originalTitle = document.title;
        const onBeforePrint = () => {
            originalTitle = document.title;
            const today = new Date();
            const dateStr = `${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}-${today.getFullYear()}`;
            const buyerPart = loiData.buyer ? ` (${loiData.buyer})` : '';
            document.title = `LOI - ${data.NAME} - ${data.CITY}, ${data.STATE}${buyerPart} ${dateStr}`;
        };
        const onAfterPrint = () => {
            document.title = originalTitle;
        };
        window.addEventListener('beforeprint', onBeforePrint);
        window.addEventListener('afterprint', onAfterPrint);
        return () => {
            window.removeEventListener('beforeprint', onBeforePrint);
            window.removeEventListener('afterprint', onAfterPrint);
        };
    }, [data, loiData]);

    const handleLOI =(event)=>{
        event.preventDefault();
        setLoiModal(true)
    }

    const updateLOIForm=(key,value)=>{
      if (['price','earnestMoney','contractConsideration','additionalDeposit'].includes(key) && value.length) {
            let inputValue = value.replace(/[^0-9.]/g, '');
            
           

            if ((inputValue.match(/\./g) || []).length > 1) {
                return; // Exit if more than one decimal point
              }

            let numericValue = formatNumberWithCommas(inputValue)

            // if (!isNaN(numericValue)) {
            //     inputValue = numericValue.toLocaleString(undefined, { maximumFractionDigits: 2 });
            // } else {
            //     inputValue = '';
            // }

            setLoiData((prevLoiData) => ({
                ...prevLoiData,
                [key]: numericValue
              }));
           
        }
        else if(['dueDeligence','close'].includes(key)){
            if (!isNaN(value) || value === '') {
                setLoiData((prevLoiData) => ({
                    ...prevLoiData,
                    [key]: value
                  }));
              }
        }
        else {
            setLoiData((prevLoiData) => ({
                ...prevLoiData,
                [key]: value
              }));
              
        }
    }

    const formatNumberWithCommas = (num) => {
        // Regular expression to format with commas, keeping decimal places intact
        const [integerPart, decimalPart] = num.split('.');
        const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return decimalPart !== undefined ? `${formattedInteger}.${decimalPart}` : formattedInteger;
      };

    const handleBlur = (key,value,suffixType='',suffix=true) => {
        // Append 'days' when input field loses focus. A percent sits against the
        // number it qualifies - "3%" - where a word suffix is spaced off it.
        if (suffix && value && !value.endsWith(suffixType)) {
            const separator = suffixType === '%' ? '' : ' ';
            setLoiData((prevLoiData) => ({
                ...prevLoiData,
                [key]: `${String(value).trimEnd()}${separator}${suffixType}`
            }))
        }
        if(!suffix && value && !value.startsWith(suffixType)) {
            const numericValue = parseFloat(value.replace(/[\$,]/g, ''));
            setLoiData((prevLoiData) => ({
                ...prevLoiData,
                [key]: `${suffixType}${numericValue.toLocaleString(undefined, {maximumFractionDigits: 2})}`
            }))
        }
      };
    
      const handleFocus = (key,value,suffixType='',suffix=true) => {
        // Remove the suffix when the field is focused, whether or not a space
        // divides it from the value - a percent carries none, and older saved
        // values were written with one.
        if (suffix && value && value.trimEnd().endsWith(suffixType)) {
            setLoiData((prevLoiData) => ({
                ...prevLoiData,
                [key]: value.trimEnd().slice(0, -suffixType.length).trimEnd()
            }))
        }

        if(!suffix && value && value.startsWith(suffixType)) {
            setLoiData((prevLoiData) => ({
                ...prevLoiData,
                [key]: value.replace(/^\$/, '')
            }))
        }

        
      };
    const updateTitleCompany=(data)=>{
      setTitleCompany(data.titleCompany)
    }

    /** Renders title company text with email part as a blue mailto link (matches "E: email" in title company VALUE). */
    const renderTitleCompanyWithEmailLink = (text) => {
      if (!text || text === "Other") return text;
      const emailMatch = text.match(/E:\s*([^\s]+@[^\s]+)/);
      if (!emailMatch) return text;
      const email = emailMatch[1];
      const beforeEmail = text.slice(0, emailMatch.index);
      const afterEmail = text.slice(emailMatch.index + emailMatch[0].length);
      return (
        <React.Fragment>
          {beforeEmail}
          E: <a href={`mailto:${email}`} className="link-website">{email}</a>
          {afterEmail}
        </React.Fragment>
      );
    }

    const image1 ='https://s3-us-west-1.amazonaws.com/arcfusion-env-01-open/arcfusion/skydata/arc11a015/media/apps/arcimedes/v0/127111ad4172f5e32d4865128426381f5cc428bccb1799d8576f13daea70c07a718b8c69051ed9022aba9977ea153962d00ee810f87462d0a6c618f82951e5c6_LOI_new_Page_1.jpg'
    const image2 = "https://s3-us-west-1.amazonaws.com/arcfusion-env-01-open/arcfusion/skydata/arc11a015/media/apps/arcimedes/v0/e6db61df05bf28a6c80b530a7212572687b6598cd3c6fcd0d9bc7ed69855e6404d58e0a363fa1b54c4d7ddd9aaf4ff1db05e19a4bf29ff6bf3b2037ee7bacae5_loi_second_page.jpg";
    const image4='https://s3-us-west-1.amazonaws.com/arcfusion-env-01-open/arcfusion/skydata/arc11a015/media/apps/arcimedes/v0/6783267dc27580a11553d3bb41b26176471d9a2fad95f9c61e64717df6573963bcf5940875c8b0d9c3aa0b67862d700b01e45f5a1eda8b780cb400ebbb841db8_LOI_PAGE_4_page-0001.jpg';
    const image5='https://s3-us-west-1.amazonaws.com/arcfusion-env-01-open/arcfusion/skydata/arc11a015/media/apps/arcimedes/v0/67b0c56a50dde823e0895cd7c8012624df84a600c911c11b804ac0745afa8b282582172f17c81a1733b922d86ccba225d1adcbd950e63fffb9e71449ae74436d_LOI_PAGE_5_page-0001.jpg';
    const image3='https://s3-us-west-1.amazonaws.com/arcfusion-env-01-open/arcfusion/skydata/arc11a015/media/apps/arcimedes/v0/b218a56408300c8935ae56233541bf67bea4520db88c5cbd858ddae2be367db4997537be2d310e3c3ec085de6cce7e8a5757e5ce4037b3ac6584f5ccb55cab68_loi_updated_3_page-0001.jpg';
    const summitLogo = 'https://storage.googleapis.com/mydev-storage/mydev-master/logo/original/oYsEouYxLcDrTHrSOe1ppJs9w24AsfTCUKteUHPk.png'
    const displayCommission = () => {
        if (!loiData.commission) {
            return `Seller agrees to pay SUMMIT a real estate commission per separate agreement`
        }
        return `Seller agrees to pay SUMMIT a ${String(loiData.commission || '').replace(/\s+/g, '')} commission at Close of Escrow`
    }

    const displayCloseOfEscrow = () => {
        if (closeBefore) {
            return `Close of Escrow shall occur on or before ${loiData.closeDate ? moment(loiData.closeDate).format('MMMM DD, YYYY') : ''}.`
        }
        return `Close of Escrow shall occur on or before ${convertToWords(loiData.close)} (${loiData.close ? loiData.close.replace(' Days', '') : 0}) days after the ${ed ? 'effective date of the formal Purchase and Sale Agreement' : 'expiration of the Feasibility Period'}`
    }

    const displayExpiration = () => (
        loiData.expiration
            ? `This offer is valid until 5:00 pm CST on ${moment(loiData.expiration).format('MMMM DD, YYYY')}`
            : 'This offer is valid until 5:00 pm CST on'
    )

    const displayLOIBG = () => {
        if (loiData.financing && !loiData.additionalDeposit) {
            return image4
        }

        if (!loiData.financing && loiData.additionalDeposit) {
            return image5
        }
        return image2
    }

    const handleClassNames=(className)=>{

        if (!loiData.financing && loiData.additionalDeposit) {
            return className + "-5"
        }
        else if (loiData.financing && !loiData.additionalDeposit) {
            return className + "-4"
        }

        return className
    }

    const renderSecondPage = () => {
        return (
            <div className="print-loi-second">
                <div>
                    <div className="summit-logo" style={{textAlign: userData && allowedEmails.includes(userData.email) ? 'left' : 'center'}}>
                        <img src={summitLogo} />
                    </div>
                    <div className="propertyInfo">
                        <table className="propertyInfo-table">
                            <tbody>
                                {loiData.financing && (
                                    <tr>
                                        <td>Financing Period:</td>
                                        <td>
                                            {loiData.financing && (
                                                <div className={handleClassNames('loi-financing')}>
                                                    {`Buyer shall have ${convertToWords(loiData.financing)} (${loiData.financing ? loiData.financing.replace(' Days', '') : 0}) days after the effective date of the formal`} Purchase and Sale Agreement to obtain a commitment for financing.  
                                                    Buyer shall apply for said financing and pay all applicable fees to lender within fourteen (14) days from the effective date of the formal Purchase and  <br /> Sale Agreement
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                )}
                                {loiData.additionalDeposit && (
                                    <tr>
                                        <td>Additional Deposit</td>
                                        <td>
                                            {loiData.additionalDeposit && (
                                                <div className={handleClassNames('additional-deposit')}>
                                                    Upon expiration of the Feasibility Period, Buyer shall deposit an additional {`${numberToWords(formatNumber(loiData.additionalDeposit))} (${loiData.additionalDeposit}) with Escrow Company`}
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                )}
                                <tr>
                                    <td>Close of Escrow</td>
                                    <td>{displayCloseOfEscrow()}</td>
                                </tr>
                                <tr>
                                    <td>Commission</td>
                                    <td>{displayCommission()}</td>
                                </tr>
                                {loiData.other && (
                                    <tr>
                                        <td>Other</td>
                                        <td>{loiData.other}</td>
                                    </tr>
                                )}
                                <tr>
                                    <td>Expiration</td>
                                    <td>{displayExpiration()}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>      
                </div>
                <div>
                    <div className="non-binding-letter-of-intent-text">
                        <p>
                            This proposal is intended to be a non-binding letter of intent which states terms and conditions upon
                            which Seller will consider selling the Property to Buyer.   Neither party shall become legally bound in any
                            manner, notwithstanding this letter of intent or any subsequent negotiations or draft agreements, unless
                            and until a formal purchase and sale agreement is executed and delivered to both parties.
                        </p>
                        <span>Sincerly,</span>
                    </div>
                    <div>
                        <div>
                            <div className="input-field-container">
                                <label>Buyer Signature:</label>
                                <span className="signature-line" />
                            </div>
                            <div className="input-field-container">
                                <label>By:</label>
                                <span className="signature-line" />
                            </div>
                            <div className="input-field-container">
                                <label>Date:</label>
                                <span className="signature-line" />
                            </div>
                        </div>
                    </div>
                    <h1 className="agreed-accepted-by-seller">Agreed & Accepted By Seller</h1>
                    <div>
                        <div className="input-field-container">
                            <label>Seller Signature:</label>
                            <span className="signature-line" />
                        </div>
                        <div className="input-field-container">
                            <label>By:</label>
                            <span className="signature-line" />
                        </div>
                        <div className="input-field-container">
                            <label>Date:</label>
                            <span className="signature-line" />
                        </div>
                    </div>
                    <div className="footer-table-container">
                        <table className="footer-table">
                            <tbody>
                                {userData && allowedEmails.includes(userData.email) ?
                                <tr>
                                    <td className="link-website">https://summitre.io/</td>
                                    <td>485 E 17th St, Suite 220 Costa Mesa, CA 92627</td>
                                    <td>(949) 781-2883</td>
                                </tr>
                                : 
                                <tr>
                                    <td className="link-website">https://summitre.io/</td>
                                    <td>14755 Preston Rd, Suite 440 Dallas, TX 75254</td>
                                    <td>(972) 860-9950</td>
                                </tr>
                                }

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    };

    const handleCheckBox =()=>{
        setCloseBefore(false);
        setEd(!ed)
    }

    // Ticking Before switches the Close field to a date; unticking hands it back
    // to whichever of ED / DD was last chosen.
    const handleCloseBeforeCheckBox =()=>{
        setCloseBefore((prev) => !prev)
    }

    const addOtherTitleCompany=(e)=>{
        e.preventDefault();
         setOtherCompany(true);
       setTitleCompany("Other")
    }
 
    const undoOtherTitleCompany=(e)=>{
        e.preventDefault();
        setOtherCompany(false);
        setAddOtherTitleCompany("")
        setTitleCompany("   ")
    }

    /**
     * The LOI as a Word document.
     *
     * The printed form lays its text over scanned letterhead images and places
     * it absolutely, which a .docx cannot carry; this builds the same terms as
     * real paragraphs instead, through the shared converter the Rep and Peak
     * agreements use. The classes are what the converter lays out from -
     * .term / .term-key / .term-value is a bold label with its value beside it,
     * .page-header the letterhead and .page-footer the running address line -
     * so the two outputs stay in step by wording rather than by geometry.
     *
     * The logo is the app's own copy rather than the S3 one the print uses:
     * the converter only embeds data: URIs, and the bucket sends no CORS
     * header, so the remote one cannot be read in the browser to become one.
     */
    const buildLoiDocument = () => {
        const esc = (value) => String(value == null ? '' : value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');

        const today = new Date();
        const dateStr = `${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}-${today.getFullYear()}`;
        const buyerPart = loiData.buyer ? ` (${loiData.buyer})` : '';
        const title = `LOI - ${data.NAME} - ${data.CITY}, ${data.STATE}${buyerPart} ${dateStr}`;

        const agent = loiData.agentInfo || {};
        const costaMesa = userData && allowedEmails.includes(userData.email);
        const footerText = costaMesa
            ? 'https://summitre.io/ &nbsp;|&nbsp; 485 E 17th St, Suite 220 Costa Mesa, CA 92627 &nbsp;|&nbsp; (949) 781-2883'
            : 'https://summitre.io/ &nbsp;|&nbsp; 14755 Preston Rd, Suite 440 Dallas, TX 75254 &nbsp;|&nbsp; (972) 860-9950';

        // One Summary row. The label is always printed, with the value blank when
        // there is nothing to say, which is what the printed form's table does.
        //
        // The inline margin is how a block asks for spacing other than its
        // class's own: .term's shape is shared with the Peak agreement, so the
        // air between these rows is set here rather than on the shape.
        const term = (label, value, topGap = 0) =>
            `<div class="term" style="${topGap ? `margin-top:${topGap}px;` : ''}margin-bottom:${TERM_GAP}px;"><span class="term-key"><strong>${esc(label)}:</strong></span><span class="term-value">${esc(value || '')}</span></div>`;

        // Financing Period and Additional Deposit are the two rows the printed
        // form leaves out altogether when they are empty, rather than printing
        // an empty one.
        const optionalTerm = (label, value) => (value ? term(label, value) : '');

        const titleCompanyText = titleCompany !== 'Other' ? titleCompany : otherTitleCompany;

        // The printed form splits these over two sheets, and the Word file keeps
        // the same break so the two read alike page for page.
        const firstPageTerms = [
            term('Property', `${data.NAME} - ${data.ADDRESS}, ${data.CITY}, ${data.STATE}`, PROPERTY_TOP_GAP),
            term('Purchase Price', loiData.price ? `${numberToWords(formatNumber(loiData.price))} (${loiData.price})` : ''),
            term('Earnest Money Deposit', `Deposit of ${numberToWords(formatNumber(loiData.earnestMoney))} (${loiData.earnestMoney}) to be placed into escrow within within three (3) days the effective date of the formal Purchase and Sale Agreement`),
            term('Contract Consideration', `Buyer shall pay a ${loiData.contractConsideration} non-refundable contract consideration fee. This fee will be applicable towards the purchase price at close`),
            term('Escrow Company/Title Company', titleCompanyText && titleCompanyText.trim()),
            term('Feasibility Period', loiData.dueDeligence
                ? `Buyer shall have ${convertToWords(loiData.dueDeligence)} (${loiData.dueDeligence.replace(' Days', '')}) days after the effective date of the formal Purchase and Sale Agreement to conduct a feasibility study on this Property`
                : ''),
        ].join('');

        const secondPageTerms = [
            optionalTerm('Financing Period', loiData.financing
                ? `Buyer shall have ${convertToWords(loiData.financing)} (${loiData.financing.replace(' Days', '')}) days after the effective date of the formal Purchase and Sale Agreement to obtain a commitment for financing. Buyer shall apply for said financing and pay all applicable fees to lender within fourteen (14) days from the effective date of the formal Purchase and Sale Agreement`
                : ''),
            optionalTerm('Additional Deposit', loiData.additionalDeposit
                ? `Upon expiration of the Feasibility Period, Buyer shall deposit an additional ${numberToWords(formatNumber(loiData.additionalDeposit))} (${loiData.additionalDeposit}) with Escrow Company`
                : ''),
            term('Close of Escrow', displayCloseOfEscrow()),
            term('Commission', displayCommission()),
            optionalTerm('Other', loiData.other),
            term('Expiration', displayExpiration()),
        ].join('');

        const header = `<div class="page-header"><img src="${SUMMIT_WORD_LOGO}" alt="Summit" /></div>`;
        const footer = `<div class="page-footer wide">${footerText}</div>`;

        const body = `
    <h2 class="center">Non-Binding Letter of Intent</h2>
    <p>${esc(moment().format('dddd, MMMM D, YYYY'))}</p>

    <div class="sig-block">
        <div class="sig-name">${esc([agent.FIRST_NAME, agent.LAST_NAME].filter(Boolean).join(' '))}</div>
        <div class="sig-name">Summit</div>
        <div class="sig-name">${esc(loiOffice && loiOffice.ADDRESS ? loiOffice.ADDRESS : '14755 Preston Rd Suite 440')}</div>
        <div class="sig-name">${esc(loiOffice && (loiOffice.CITY != null || loiOffice.STATE != null) ? [loiOffice.CITY, loiOffice.STATE, loiOffice.ZIP].filter(Boolean).join(', ') : 'Dallas, TX 75254')}</div>
        <div class="sig-name">Phone: ${esc(agent.PHONE || '')}</div>
        <div class="sig-name">Email: ${esc(agent.EMAIL || '')}</div>
    </div>

    <p>Re: ${esc(`${data.NAME} - ${data.CITY}, ${data.STATE}`)}</p>
    <p>${agent.FIRST_NAME ? esc(`Dear ${String(agent.FIRST_NAME).trim()},`) : ''}</p>
    <p>${esc(`On behalf of ${loiData.buyer} and/or Assigns (“Buyer”), I am pleased to present to you this Non-Binding Letter of Intent based on the terms and conditions outlined below. This document is not a contract, but is intended to outline the basic business terms needed to negotiate, draft and enter into a Purchase and Sale Agreement.`)}</p>

    <div class="summary">${firstPageTerms}</div>

    <div class="page-start"><div class="summary">${secondPageTerms}</div></div>

    <p style="margin-top:${NON_BINDING_GAP}px;margin-bottom:${NON_BINDING_GAP}px;">This proposal is intended to be a non-binding letter of intent which states terms and conditions upon which Seller will consider selling the Property to Buyer. Neither party shall become legally bound in any manner, notwithstanding this letter of intent or any subsequent negotiations or draft agreements, unless and until a formal purchase and sale agreement is executed and delivered to both parties.</p>

    <p>Sincerly,</p>

    <div class="sig-line">Buyer Signature: __________________________________</div>
    <div class="sig-line">By: __________________________________</div>
    <div class="sig-line">Date: __________________________________</div>

    <h2>Agreed &amp; Accepted By Seller</h2>
    <div class="sig-line">Seller Signature: __________________________________</div>
    <div class="sig-line">By: __________________________________</div>
    <div class="sig-line">Date: __________________________________</div>
`;

        return { title, wordHtml: `${header}${body}${footer}` };
    };

    const downloadLoiWord = async (e) => {
        e.preventDefault();
        const { title, wordHtml } = buildLoiDocument();
        try {
            await downloadDocumentWord(await withEmbeddedImages(wordHtml), title, LOI_WORD_FONT_SIZE);
        } catch (error) {
            console.error('Could not build the LOI Word document: ', error);
        }
    };

    const storeLoiData=(e)=>{
        e.preventDefault();
        window.print();
        const formData =[{
            BUYER:loiData.buyer,
            EARNEST_MONEY:loiData.earnestMoney,
            CONTRACT_CONSIDERATION:loiData.contractConsideration,
            DUE_DILIGENCE:loiData.dueDeligence,
            FINANCING:loiData.financing,
            ADDITIONAL_DEPOSIT:loiData.additionalDeposit,
            // LOI_DATA has no column for the close date, so a "Before" close is
            // recorded as the date it names rather than a day count.
            CLOSE:closeBefore ? `Before ${loiData.closeDate}` : loiData.close,
            COMISSION:loiData.commission,
            EXPIRATION:loiData.expiration,
            TITLE_COMPANY:titleCompany,
            AGENT_ID:`propertyId:${data.ARCIMEDES_ROW_ID},agentId:${loiData.agentInfo && Object.keys(loiData.agentInfo).length && loiData.agentInfo.ARCIMEDES_ROW_ID},price:${loiData.price}`
        }]
        manageData({tableCode: STORE_LOI_DATA, data:formData}).then(res => {
            if (!res.success) {
                console.error("error: ", res)
            } 
        });
    }
    return (
        <React.Fragment>
            <div className="print-loi-first" style={{ backgroundImage: `url(${image1})` }}>
                <div className="summit-logo" style={{textAlign: userData && allowedEmails.includes(userData.email) ? 'left' : 'center'}}>
                    <img src={summitLogo} />
                </div>
                <span className="non-binding-letter-of-intent">Non-Binding Letter of Intent</span>
                <div className="todaysDate">
                    {moment().format("dddd, MMMM D, YYYY")}
                </div>
                <div className="agentInfo">
                    {loiData && loiData.agentInfo && loiData.agentInfo.FIRST_NAME && `${loiData.agentInfo.FIRST_NAME} ${loiData.agentInfo.LAST_NAME}`}
                    <br/>Summit
                    <br/>{loiOffice && loiOffice.ADDRESS ? loiOffice.ADDRESS : '14755 Preston Rd Suite 440'}
                    <br/>{loiOffice && (loiOffice.CITY != null || loiOffice.STATE != null) ? [loiOffice.CITY, loiOffice.STATE, loiOffice.ZIP].filter(Boolean).join(', ') : 'Dallas, TX 75254'}
                    {/* <br/>{loiData && loiData.agentInfo && loiData.agentInfo.ADDRESS && `${loiData.agentInfo.ADDRESS}`}
                    <br/>{loiData && loiData.agentInfo && loiData.agentInfo.CITY && `${loiData.agentInfo.CITY}, ${loiData.agentInfo.STATE} ${loiData.agentInfo.ZIP}`} */}
                    <br/>{`Phone: ${(loiData && loiData.agentInfo && loiData.agentInfo.PHONE) || ''}`}
                    <br/>Email: {loiData && loiData.agentInfo && loiData.agentInfo.EMAIL ? <a href={`mailto:${loiData.agentInfo.EMAIL}`} className="link-website">{loiData.agentInfo.EMAIL}</a> : ''}
                </div>
                <div className="description">
                    {`Re: ${data.NAME} - ${data.CITY}, ${data.STATE}`}
                    <br/>
                    <br/>
                    {loiData && loiData.agentInfo && loiData.agentInfo.FIRST_NAME && `Dear ${loiData.agentInfo.FIRST_NAME.trim()},`}
                    <br/>
                    <br/>
                    {`On behalf of ${loiData.buyer} and/or Assigns (“Buyer”), I am pleased to present to you this Non-Binding `} Letter of Intent based on the terms and conditions outlined below. This document is not a contract, but is intended to outline the basic business terms needed to negotiate, draft and enter into a Purchase and Sale Agreement.
                </div>
                <div className="propertyInfo">
                    <table className="propertyInfo-table">
                        <tbody>
                            <tr>
                                <td>Property:</td>
                                <td>{`${data.NAME} - ${data.ADDRESS}, ${data.CITY}, ${data.STATE}`}</td>
                            </tr>
                            <tr>
                                <td>Purchase Price:</td>
                                <td>{loiData.price && `${numberToWords(formatNumber(loiData.price))} (${loiData.price})`}</td>
                            </tr>
                            <tr>
                                <td>Earnest Money Deposit:</td>
                                <td>{`Deposit of ${numberToWords(formatNumber(loiData.earnestMoney))} (${loiData.earnestMoney}) to be placed into escrow within within three (3) days the effective date of the formal Purchase and Sale Agreement`}</td>
                            </tr>
                            <tr>
                                <td>Contract Consideration:</td>
                                <td>{`Buyer shall pay a ${loiData.contractConsideration} non-refundable contract consideration fee. This fee will be applicable towards the purchase price at close`}</td>
                            </tr>
                            <tr>
                                <td>Escrow Company/Title Company</td>
                                <td>{titleCompany !== "Other" ? renderTitleCompanyWithEmailLink(titleCompany) : otherTitleCompany}</td>
                            </tr>
                            <tr>
                                <td>Feasibility Period:</td>
                                <td>
                                {
                                loiData.dueDeligence && (
                                    <div>
                                        {`Buyer shall have ${convertToWords(loiData.dueDeligence)} (${loiData.dueDeligence ? loiData.dueDeligence.replace(' Days',''):0}) days after the effective date of the formal Purchase`} and Sale Agreement to conduct a feasibility study on this Property
                                        </div>
                                    )
                                }
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div> 
                <div className="footer-table-container">
                    <table className="footer-table">
                        <tbody>
                            {userData && allowedEmails.includes(userData.email) ?
                            <tr>
                                <td className="link-website">https://summitre.io/</td>
                                <td>485 E 17th St, Suite 220 Costa Mesa, CA 92627</td>
                                <td>(949) 781-2883</td>
                            </tr>
                            : 
                            <tr>
                                <td className="link-website">https://summitre.io/</td>
                                <td>14755 Preston Rd, Suite 440 Dallas, TX 75254</td>
                                <td>(972) 860-9950</td>
                            </tr>
                            }

                        </tbody>
                    </table>
                </div>
            </div> 
            {renderSecondPage()}
            <Modal className='loi-main' show={loiModal} onClose={() => resetLOIForm()}>
                <div className='loi-modal'>
                    <span className='green-title'> Create LOI </span>
                    <div className='close-button' onClick={() => resetLOIForm()} />
                </div>
                <div className='loi-modal-content' style={{ display: "grid", gap: "80px", gridTemplateColumns: "400px 400px 400px" }}>
                    <div>
                        <Input label='BUYER'
                            onChange={(event)=>updateLOIForm("buyer",event.target.value)}
                            value={loiData.buyer}
                        />
                        <Input
                            label='PRICE'
                            onChange={(event)=>updateLOIForm("price",event.target.value)}
                            value={loiData.price}
                            handleParentBlur={(key, value) => handleBlur('price',value,'$',false)}
                            handleInputFocus={()=>handleFocus('price',loiData.price,'$',false)}
                        />
                        <Input
                            label='EARNEST MONEY'
                            onChange={(event)=>updateLOIForm("earnestMoney",event.target.value)}
                            value={loiData.earnestMoney}
                            handleParentBlur={(key, value) => handleBlur('earnestMoney',value,'$',false)}
                            handleInputFocus={()=>handleFocus('earnestMoney',loiData.earnestMoney,'$',false)}
                        />
                        <div style={{display:"flex",gap:"10px",alignItems:"center"}}>
                        <Dropdown label='Title Company'
                            optionsType="title-companies"
                            customValues
                            className="title-company"
                            handleParentChange={updateTitleCompany}
                            valueKey="titleCompany"
                            value={titleCompany}
                            disabled={otherCompany}
                            optionLabelKey='LABEL'
                            optionKey={"VALUE"}
                            disablePortal={true}
                        />
                        <button className='button-new plus positive' onClick={(e) => addOtherTitleCompany(e)}>+</button>
                        </div>
                        {
                           otherCompany && <div style={{display:"flex",gap:"10px",alignItems:"center"}}>
                           <Input
                            label='TITLE COMPANY NAME'
                            onChange={(event)=>setAddOtherTitleCompany(event.target.value)}
                            value={otherTitleCompany}
                            className="title-company-other"
                        />
                        <button className='button-new negative' onClick={(e) => undoOtherTitleCompany(e)}>Remove</button>
                        </div>
                        }
                    </div>
                    <div >
                        <Input
                            // valueType="integer"
                            label='DUE DILIGENCE'
                            onChange={(event) => updateLOIForm("dueDeligence", event.target.value)}
                            value={loiData.dueDeligence}
                            handleParentBlur={(key, value) => handleBlur('dueDeligence',value,'Days')}
                            handleInputFocus={()=>handleFocus('dueDeligence',loiData.dueDeligence,'Days')}
                        />
                        <div className="close-section">
                                CLOSE
                            <Checkbox
                                text="ED"
                                type="checkable"
                                isSelected={ed && !closeBefore}
                                handleClick={handleCheckBox}
                                name="ED"
                            />
                             <Checkbox
                                text="DD"
                                type="checkable"
                                isSelected={!ed && !closeBefore}
                                handleClick={handleCheckBox}
                                name="DD"
                            />
                             <Checkbox
                                text="Before"
                                type="checkable"
                                isSelected={closeBefore}
                                handleClick={handleCloseBeforeCheckBox}
                                name="Before"
                            />
                        </div>
                        {closeBefore ? (
                            <Input
                                className="close-field"
                                type="date"
                                format="mm/dd/yyyy"
                                onChange={(event) => updateLOIForm("closeDate", event.target.value)}
                                value={loiData.closeDate}
                            />
                        ) : (
                            <Input className="close-field"
                                onChange={(event) => updateLOIForm("close", event.target.value)}
                                value={loiData.close}
                                handleParentBlur={(key, value) => handleBlur('close', value, 'Days')}
                                handleInputFocus={() => handleFocus('close', loiData.close, 'Days')}
                            />
                        )}
                        <Input label='Expiration'
                            // valueType="iso-date"
                            type="date"
                            format="mm/dd/yyyy"
                            onChange={(event) => updateLOIForm("expiration", event.target.value)}
                            value={loiData.expiration}
                        />
                        <div>
                            <label className="input-label" style={{ display: 'block', marginBottom: '4px' }}>Other</label>
                            <textarea
                                className="input loi-other"
                                style={{ width: '100%', minHeight: '80px', padding: '10px', fontFamily: 'inherit' }}
                                value={loiData.other}
                                onChange={(event) => updateLOIForm("other", event.target.value)}
                            />
                        </div>
                    </div>
                    <div>
                        <Input label='Commission'
                            value={loiData.commission}
                            onChange={(event)=>updateLOIForm("commission",event.target.value)}
                            handleParentBlur={(key, value) => handleBlur('commission',value,'%')}
                            handleInputFocus={()=>handleFocus('commission',loiData.commission,'%')}
                        />
                        <Input
                            name='contractConsideration'
                            label='CONTRACT CONSIDERATION'
                            onChange={(event)=>updateLOIForm("contractConsideration",event.target.value)}
                            value={loiData.contractConsideration}
                            handleParentBlur={(key, value) => handleBlur('contractConsideration',value,'$',false)}
                            handleInputFocus={()=>handleFocus('contractConsideration',loiData.contractConsideration,'$',false)}
                        />
                        <Input
                           handleParentBlur={(key, value) => handleBlur('financing',value,'Days')}
                           handleInputFocus={()=>handleFocus('financing',loiData.financing,'Days')}
                            label='Financing'
                            onChange={(event)=>updateLOIForm("financing",event.target.value)}
                            value={loiData.financing}
                        />
                        <Input
                            label='Additional Deposit'
                            onChange={(event)=>updateLOIForm("additionalDeposit",event.target.value)}
                            value={loiData.additionalDeposit}
                            handleParentBlur={(key, value) => handleBlur('additionalDeposit',value,'$',false)}
                            handleInputFocus={()=>handleFocus('additionalDeposit',loiData.additionalDeposit,'$',false)}
                        />
                    </div>
                </div>
                <div className="modal-buttons" style={{ display: 'flex', justifyContent: "flex-end", gap: "20px" }}>
                    <button className='button-new negative' onClick={(e) => downloadLoiWord(e)}>Word</button>
                    <button className='button-new positive' onClick={(e) => {storeLoiData(e)}}>Submit</button>
                    <button className='button-new negative' onClick={() => resetLOIForm()}>Cancel</button>
                </div>
            </Modal>
            <div className="Listing-agent">
                <div className="Listing-agent_column">
                    <div className="Listing-agent_column_item" style={{ position: 'relative', display: 'flex', flexDirection: 'row', alignItems: 'flex-end', gap: '12px' }}>
                        <div style={{ flex: 1, minWidth: 0}}>
                            <SelectTeam
                                isFromProperty
                                value={data.LISTING_AGENT_1}
                                valueKey="LISTING_AGENT_1"
                                percentKey="LISTING_AGENT_1_PERCENT"
                                percentDisabled={isFieldLocked(locks, "LISTING_AGENT_1_PERCENT")}
                                label="Listing Agent 1"
                                data={data}
                                hasAgentPercent={true}
                                handleParentChange={handleChangeDropdown}
                                handleInputParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                onlySummitAgents
                            />
                        </div>
                        {data.LISTING_AGENT_1 && <button type="button" className="button-new text" style={{ color: '#90b9ed', flexShrink: 0, position: 'absolute', right: 0, bottom: "-8px" }} onClick={handleSyncFirmListingAgent1}>SYNC FIRM</button>}
                    </div>

                    <SelectTeam
                        className="Listing-agent_column_item"
                        isFromProperty
                        value={data.LISTING_AGENT_2}
                        valueKey="LISTING_AGENT_2"
                        percentKey="LISTING_AGENT_2_PERCENT"
                        percentDisabled={isFieldLocked(locks, "LISTING_AGENT_2_PERCENT")}
                        label="Listing Agent 2"
                        data={data}
                        hasAgentPercent={true}
                        handleParentChange={handleChangeDropdown}
                        handleInputParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        onlySummitAgents
                    />
                    <SelectTeam
                        className="Listing-agent_column_item"
                        isFromProperty
                        value={data.LISTING_AGENT_3}
                        valueKey="LISTING_AGENT_3"
                        percentKey="LISTING_AGENT_3_PERCENT"
                        percentDisabled={isFieldLocked(locks, "LISTING_AGENT_3_PERCENT")}
                        label="Listing Agent 3"
                        data={data}
                        hasAgentPercent={true}
                        handleParentChange={handleChangeDropdown}
                        handleInputParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        onlySummitAgents
                    />
                    <div className="Listing-agent_column_item" style={{ position: 'relative' }}>
                        <SelectAgent
                            isFromProperty
                            value={data.LISTING_AGENT_4}
                            valueKey="LISTING_AGENT_4"
                            percentKey="LISTING_AGENT_4_PERCENT"
                            percentDisabled={isFieldLocked(locks, "LISTING_AGENT_4_PERCENT")}
                            label="Outside Agent"
                            data={data}
                            hasAgentPercent={true}
                            handleParentChange={handleChangeDropdown}
                            handleInputParentChange={handleChangeInput}
                            withAddNew={true}
                            addNewItem={addNewItem}
                            viewMode={viewMode}
                            deleted={deleted}
                            newAgent={newAgent}
                            syncButton={true}
                            viewModeExtra={data.LISTING_AGENT_4_LEAD_ID ? <OpenInCrmButton leadId={data.LISTING_AGENT_4_LEAD_ID} variant="link" /> : null}
                        />
                        {data.LISTING_AGENT_4 && <button type="button" className="button-new text" style={{ color: '#90b9ed', position: 'absolute', right: 0, bottom: "-8px" }} onClick={handleSyncFirmOutsideAgent}>SYNC FIRM</button>}
                    </div>
                    <SelectFirm
                        className="Listing-agent_column_item"
                        isFromProperty
                        value={data.LISTING_AGENT_4_FIRM}
                        valueKey="LISTING_AGENT_4_FIRM"
                        label="Listing Agent Firm"
                        data={data}
                        handleParentChange={handleChangeDropdown}
                        withAddNew={true}
                        addNewItem={addNewItem}
                        viewMode={viewMode}
                        deleted={deleted}
                        newFirm={newFirm}
                    />                    
                </div>
                <div className="Listing-agent_column">
                    <div className="Listing-agent_column_item" style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'flex-start' }}>
                        <button className="Listing-agent_column_item_loi button-new text" onClick={(e) => handleLOI(e)}>Letter of Intent (LOI)</button>
                    </div>
                    <div className="Listing-agent_column_item"></div>
                    <div className="Listing-agent_column_item"></div>                    
                    <SelectAgent
                        className="Listing-agent_column_item"
                        isFromProperty
                        value={data.REFERRING_LISTING_AGENT}
                        valueKey="REFERRING_LISTING_AGENT"
                        percentKey="REFERRING_LISTING_AGENT_PERCENT"
                        percentDisabled={isFieldLocked(locks, "REFERRING_LISTING_AGENT_PERCENT")}
                        label="Referring Agent"
                        data={data}
                        hasAgentPercent={true}
                        handleParentChange={handleChangeDropdown}
                        handleInputParentChange={handleChangeInput}
                        withAddNew={true}
                        addNewItem={addNewItem}
                        viewMode={viewMode}
                        deleted={deleted}
                        newAgent={newAgent}
                    />                                    
                    <SelectFirm
                        className="Listing-agent_column_item"
                        isFromProperty
                        value={data.REFERRING_LISTING_AGENT_FIRM}
                        valueKey="REFERRING_LISTING_AGENT_FIRM"
                        label="Referring Agent Firm"
                        data={data}
                        handleParentChange={handleChangeDropdown}
                        withAddNew={true}
                        addNewItem={addNewItem}
                        viewMode={viewMode}
                        deleted={deleted}
                        newFirm={newFirm}
                    />                    
                </div>
            </div>
        </React.Fragment>
        
    );
};

export default ListingAgent;